import { VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { useState } from 'react';

import { TabSelector } from '../../../../components/TabSelector';

import { EquityContent } from './components/EquityContent';
import { FixedIncomeContent } from './components/FixedIncomeContent';
import { FundsContent } from './components/FundsContent';
import { PrivatePensionContent } from './components/PrivatePensionContent';
import { PublicOfferContent } from './components/PublicOfferContent';

export namespace ProductTabsTypes {
  export type ProductTabsProps = any & {
    id: string;
    selected: boolean;
    operationsTabs: any[];
  };
}

export const ProductTabs = () => {
  const tabs = {
    funds: {
      label: 'Fundos',
      component: FundsContent,
    },
    fixedIncome: {
      label: 'Renda Fixa',
      component: FixedIncomeContent,
    },
    equity: {
      label: 'Renda Variável',
      component: EquityContent,
    },
    publicOffer: {
      label: 'Oferta Pública',
      component: PublicOfferContent,
    },
    privatePension: {
      label: 'Previdência',
      component: PrivatePensionContent,
    },
  };

  const [selectedTab, setSelectedTab] = useState<keyof typeof tabs>('funds');
  const isMobile = useBreakpointValue({ base: true, md: false });

  const handlePress = (id: keyof typeof tabs) => {
    setSelectedTab(id);
  };

  const Component = tabs[selectedTab]?.component;

  return (
    <VStack w="full" space="stack.xxs">
      <TabSelector
        selectedTab={selectedTab}
        setSelectedTab={handlePress}
        tabList={tabs}
        isMobile={isMobile}
      />
      {!!tabs[selectedTab]?.component && <Component />}
    </VStack>
  );
};
